import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
const UpdateSingleAppointment = async (e, appointmentId) => {
  /**
   * input: appointment data object + appointment Id
   * output: appointment document / collection
   * description: update appointment / appointment document
   */
  try {
    const appointmentDoc = await doc(db, "appointments", appointmentId);

    const data = HelperForMetaData({
      ...e,
      bid: getLocalStorageItem("bid"),
    });
    delete data.createdAt;
    const result = await updateDoc(appointmentDoc, data);
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default UpdateSingleAppointment;
